// Group definitions match backend services/system_dependencies.py.
// Reordered so critical deps surface first.
export const GROUPS = [
  {
    title: "Críticos del sistema",
    description:
      "Sin estos el servidor falla o las features clave (OCR, KYC PDF) no funcionan.",
    keys: [
      "poppler", "pdfinfo", "tesseract", "tesseract_spa", "tesseract_eng",
      "weasyprint", "libpango", "libcairo",
    ],
    severity: "critical",
  },
  {
    title: "Importantes",
    description:
      "Sin estos la descarga automática de CURP (Playwright) deja de funcionar.",
    keys: ["chromium", "playwright", "libnss3", "libgbm"],
    severity: "important",
  },
  {
    title: "Soporte (Python)",
    description: "Librerías de apoyo para el pipeline OCR y storage.",
    keys: ["pypdf2", "pdf2image", "pytesseract", "boto3"],
    severity: "support",
  },
];

// Friendly names so badges read well in Spanish.
export const PRETTY = {
  poppler: "poppler-utils (pdftoppm)",
  pdfinfo: "poppler-utils (pdfinfo)",
  tesseract: "Tesseract OCR",
  tesseract_spa: "Tesseract — pack Español",
  tesseract_eng: "Tesseract — pack English",
  weasyprint: "WeasyPrint",
  libpango: "libpango-1.0",
  libcairo: "libcairo",
  chromium: "Chromium (Playwright)",
  playwright: "Playwright (Python)",
  libnss3: "libnss3",
  libgbm: "libgbm",
  pypdf2: "PyPDF2",
  pdf2image: "pdf2image",
  pytesseract: "pytesseract",
  boto3: "boto3 (S3 / DO Spaces)",
};

export const BUCKET_COLOR = {
  healthy: "bg-emerald-500",
  degraded: "bg-amber-500",
  unhealthy: "bg-red-500",
  unknown: "bg-slate-700/60",
};

export const EXT_STATUS_BADGE = {
  ok:   { cls: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
          dot: "bg-emerald-400", label: "OK" },
  warn: { cls: "bg-amber-500/10 text-amber-300 border-amber-500/30",
          dot: "bg-amber-400",   label: "Advertencia" },
  fail: { cls: "bg-red-500/10 text-red-300 border-red-500/30",
          dot: "bg-red-400",     label: "Falla" },
};

export const SCREENING_STATUS_BADGE = {
  done:    { cls: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30", label: "OK" },
  failed:  { cls: "bg-red-500/10 text-red-300 border-red-500/30",             label: "Falló" },
  running: { cls: "bg-blue-500/10 text-blue-300 border-blue-500/30",          label: "En curso" },
  queued:  { cls: "bg-slate-500/10 text-slate-300 border-slate-500/30",       label: "En cola" },
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
